/* eslint-disable */
// WARNING: Generated during build from Amplify Gen 2 outputs.
const awsmobile = {
  "aws_project_region": "ap-southeast-1",
  "aws_cognito_region": "ap-southeast-1",
  "aws_user_pools_id": "ap-southeast-1_BCYpSpipu",
  "aws_user_pools_web_client_id": "5kiecukqhb02ube57go7su5clq",
  "aws_cognito_identity_pool_id": "ap-southeast-1:65b994ec-eb45-4035-aa3e-1b47cbd6a54f",
  "oauth": {}
};
export default awsmobile;
